// Types added here will need the following logic implemented:
//
// 0. yup validation of the data requirements in `addToCart` in `checkoutActions.js`.
// 1. `get{itemType}CartItem` helper in `helpers.js`
// 2. `get{itemType}CartItemPrice` helper in helpers.js
// 2. Fill in the type in `cartItemExists` in `helpers.js`
// 3. `toggle{itemType}CartItem` thunk action in `checkoutActions.js`
// 4. Create all selectors for the particular item in `cartSelectors.js`:
//  i.e.: `get{itemType}CartItems`, `get{itemType}CheckoutItem` and `getCheckoutCartCheckoutItems`
// 5. If the cart item requires/needs shipping make sure it's accommodated in the `checkoutCartRequiresAddress` selector.
// 6. Create a new cart item component for checkout/services/components/CheckoutCartItem.js
//
// And of course tests for all the above.

/**
 * Cart item type for the Cart service
 *
 * @enum CART_ITEM
 * @type {{DIGITAL_DOWNLOAD: string, PHOTO_DOWNLOAD: string, ALBUM_CUSTOM_PRINT: string, LEGACY_PRINT: string, ALBUM_SUBSCRIPTION: string, ALBUM_FOLDER_SUBSCRIPTION: string, ALBUM_PRINT_PACKAGE: string, INDIVIDUAL_PRINT: string, PRINT_PRODUCT: string, PURCHASED_PRINT_PACKAGE: string}}
 */
const CART_ITEM = {
  ALBUM_FOLDER_SUBSCRIPTION: 'checkout/ALBUM_FOLDER_SUBSCRIPTION',
  ALBUM_SUBSCRIPTION: 'checkout/ALBUM_SUBSCRIPTION',
  ALBUM_CUSTOM_PRINT: 'checkout/ALBUM_CUSTOM_PRINT',
  ALBUM_PRINT_PACKAGE: 'checkout/ALBUM_PRINT_PACKAGE',
  DIGITAL_DOWNLOAD: 'checkout/DIGITAL_DOWNLOAD',
  PHOTO_DOWNLOAD: 'checkout/PHOTO_DOWNLOAD',
  INDIVIDUAL_PRINT: 'checkout/INDIVIDUAL_PRINT',
  LEGACY_PRINT: 'checkout/LEGACY_PRINT',
  PRINT_PRODUCT: 'checkout/PRINT_PRODUCT',
  PHOTO_PRICING_PRINT_PRODUCT: 'checkout/PHOTO_PRICING_PRINT_PRODUCT',
  PURCHASED_PRINT_PACKAGE: 'checkout/PURCHASED_PRINT_PACKAGE',
  PURCHASED_DIGITAL_DOWNLOAD: 'checkout/PURCHASED_DIGITAL_DOWNLOAD',
  PURCHASED_PHOTO_PRICING_PRINT_PRODUCT:
    'checkout/PURCHASED_PHOTO_PRICING_PRINT_PRODUCT',
  PURCHASED_CUSTOM_PRINT: 'checkout/PURCHASED_CUSTOM_PRINT',
  DIGITAL_BUNDLE: 'checkout/DIGITAL_BUNDLE',
  PRINT_ORDER_SERVICE: 'checkout/PRINT_ORDER_SERVICE',
};

export default CART_ITEM;
